
import React from 'react'
import { AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import CustomAccordion from '../Accordian/accordian'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useGetOperatorGuidesQuery } from '../../api/endpoints/apiConfig';
import { facility } from '../../models/DashboardInformation';
interface FacilityInformationProps {
    data: facility | null;
}

const FacilityNotes: React.FC<FacilityInformationProps> = ({ data }) => {
    const operatorId = sessionStorage.getItem('operatorId');
    const { data: FacilityOperatorAlerts } = useGetOperatorGuidesQuery(operatorId ? parseInt(operatorId) : 0);
     // Function to remove HTML tags from a string
     const removeHtmlTags = (text: string | null | undefined): string => {
        if (!text) {
            return ''; // Return an empty string for null or undefined input
        }

        // Decode any remaining HTML entities like &nbsp; and normalize spaces
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        const decodedText = textArea.value.replace(/\s+/g, ' ').trim();

        return decodedText;
    };
    

    if (!data) {
        return (
            <CustomAccordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography variant="h3" color="text.secondary">Facility Notes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    No Facility Notes available.
                </AccordionDetails>
            </CustomAccordion>
        );
    }
    const callsxript = data?.guides || [];
    const OperatorAlert = FacilityOperatorAlerts?.guides || [];
    const script = callsxript[0]?.facility_general_notes || OperatorAlert[0]?.facility_general_notes || '';
    // Sanitize the script by removing HTML tags
    const sanitizedScript = removeHtmlTags(script);
    return (
        <CustomAccordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant="h3" color="text.secondary">Facility Notes
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
            <Typography
                    color="text.primary"
                    textAlign={'left'}
                    dangerouslySetInnerHTML={{ __html: sanitizedScript }}
                />
            </AccordionDetails>
        </CustomAccordion>
    )
}
export default FacilityNotes